/** @format */

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { AnalyticsService, CookieService, Logger, WINDOW } from '@shared/data-access/services';

import { ReviewEvents } from '../model/review.summary.interface';

/** @dynamic */
@Injectable({
	providedIn: 'root'
})
export class ProductReviewAnalyticsService extends AnalyticsService {
	constructor(
		@Inject(DOCUMENT) protected document: Document,
		@Inject(WINDOW) protected window: Window,
		protected cookieService: CookieService,
		protected logger: Logger
	) {
		super(document, window, cookieService, logger);
	}

	fireReviewAnalytics<T>(reviewEvent: ReviewEvents<T>) {
		this.setEventType(reviewEvent.name);
		this.triggerAnalyticsEvent(reviewEvent.name, reviewEvent.payload);
	}
}
